import { Injectable } from '@angular/core';
import { IListService } from '@captiveaire/advanceddropdown';
import { QueryService } from '@captiveaire/query';
import { IGridPagedResult } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IQuery } from '@captiveaire/query';

export interface IReportTemplateSearchCriteria extends IQuery {
    hasQueries?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class ReportTemplateService implements IListService {
    public static $name: string = 'reportTemplateService';

    constructor(
        private queryService: QueryService,
        private proxyService: ProxyService
    ) {
    }

    public getList(query: IReportTemplateSearchCriteria):
        angular.IPromise<IGridPagedResult<CASLink.Ui.ViewModel.Device.ReportTemplateSummary>> {
            const sort = (query.ascending) ? 0 : 1;
            const hasQueries = query.hasQueries ? query.hasQueries : true;
            return this.proxyService.request({
                endPoint: this.getEndpointName(),
                queryParams: {
                    'searchCriteria.hasQueries': hasQueries,
                    'searchCriteria.pagingCriteria.includeTotalCount': query.includeTotalCount,
                    'searchCriteria.pagingCriteria.skip': (query.page - 1) * query.limit,
                    'searchCriteria.pagingCriteria.sortDirection': sort,
                    'searchCriteria.pagingCriteria.sortExpressions': [query.getOrderWithCapitalized()],
                    'searchCriteria.pagingCriteria.take': query.limit,
                    'searchCriteria.id': query.id,
                    'searchCriteria.wildcard': query.wildcard,
                },
                route: 'getReportTemplates'
            }
            ).as<IGridPagedResult<CASLink.Ui.ViewModel.Device.ReportTemplateSummary>>();
    }

    public getListItem(id: string):
        angular.IPromise<IGridPagedResult<CASLink.Ui.ViewModel.Device.ReportTemplateSummary>> {
        const query = this.queryService.createQuery(1, 'Id', 1, true);
        query.id = id;
        return this.getList(query);
    }

    public getEndpointName() {
        return 'reportTemplate';
    }
}
